import PropTypes from "prop-types"
import React from "react"
import Autocomplete from "components/admin/autocomplete"
import RegistrationsPropTypes from "utils/prop_types"

const { string, func } = PropTypes

export default class extends React.Component {
  static displayName = "AddressAutocomplete"

  static propTypes = {
    formattedAddress: string,
    location: RegistrationsPropTypes.Location,
    onChange: func.isRequired
  }

  state = {
    searchResults: [],
    formattedAddress: this.props.formattedAddress || ""
  }

  handleChange = formattedAddress => {
    if (formattedAddress) {
      this.getAutocompleteService().getPlacePredictions(
        { input: formattedAddress },
        this.handlePredictionResponse
      )
      this.props.onChange({
        formattedAddress,
        locationData: this.getCustomLocationData(formattedAddress)
      })
      this.setState({ formattedAddress })
    } else {
      this.props.onChange({ locationData: {}, formattedAddress })
      this.setState({ searchResults: [], formattedAddress })
    }
  }

  handleSelect = placeId => {
    if (placeId) {
      this.getGeocoder().geocode({ placeId }, this.handleGeocodeResponse)
    }
  }

  handleBlur = () => {
    this.setState({ searchResults: [] })
  }

  handlePredictionResponse = (results, _status) => {
    const searchResults = results || []

    this.setState({ searchResults })
  }

  handleGeocodeResponse = (geocodeResults = [], _status) => {
    if (geocodeResults.length < 1) {
      return
    }

    const { formatted_address, address_components, geometry } = geocodeResults[0]
    const nextState = {
      searchResults: [],
      formattedAddress: formatted_address
    }
    const locationData = {
      latitude: geometry.location.lat(),
      longitude: geometry.location.lng(),
      formatted_address,
      address_data: address_components
    }

    this.props.onChange({
      locationData,
      formattedAddress: locationData.formatted_address
    })
    this.setState(nextState)
  }

  getAutocompleteService = () => {
    if (!this.autocompleteService) {
      this.autocompleteService = new google.maps.places.AutocompleteService()
    }

    return this.autocompleteService
  }

  getGeocoder = () => {
    if (!this.geocoder) {
      this.geocoder = new google.maps.Geocoder()
    }

    return this.geocoder
  }

  getCustomLocationData = formattedAddress => {
    return {
      latitude: this.props.location.latitude,
      longitude: this.props.location.longitude,
      address_data: [
        {
          long_name: formattedAddress,
          short_name: formattedAddress,
          types: ["custom", "full_address"]
        }
      ]
    }
  }

  getSearchResults = () => {
    return this.state.searchResults.map(searchResult => {
      return { value: searchResult.place_id, name: searchResult.description }
    })
  }

  render() {
    return (
      <Autocomplete
        value={this.state.formattedAddress}
        placeholder="Street address"
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        onBlur={this.handleBlur}
        results={this.getSearchResults()}
      />
    )
  }
}
